export default function (): FilterStore {
    return {
        ...filterData,
        mobileViewOpened: false,
        selectedParams: Object.keys(filterData.filterParams ?? {})
            .reduce<QueryParams>((params, key) => {
                const isSingle = filterData?.filterParams[key].single ?? false,
                    queryValue = typeof archiveData !== 'object' ? null : archiveData?.query[key]

                return {... params, [key]: isSingle ? queryValue ?? "default" : queryValue?.split(",") ?? [] }
            }, {}),
        get selectedParamsTags() {
            let tags: FilterTerm[] = []
            Object.entries(this.selectedParams).forEach(([key, value]) => {
                const parameter = this.filterParams[key],
                    terms = Array.isArray(value) ? value : [value]

                tags = [ ...tags, ...(!parameter.range
                        ? (parameter.terms?.filter((term: FilterTerm) => terms.includes(term.slug)) ?? [])
                        : value != 'default' ? [{ key: key, slug: value, name : (parameter.tagTemplate ?? '%value%')
                                .replace('%value%', ` ${parseInt(<string>value).toLocaleString()} `) }] : []
                )]
            })

            return tags
        },
        get selectedParamsCount() {
            return document.body.classList.contains('is-mobile') ? Object.values(this.selectedParams)
                .reduce<number>((count, params: string | string[]) => {
                    return count + (Array.isArray(params) ? params.length
                        : (params.length && params !== "default" ? 1 : 0))
                }, 0) : 0
        },
        get selectedFieldsQuery() {
            return [...this.selectedInterest, ...this.selectedLocality]
                .reduce<QueryFields>((args, term: SearchResult) => {
                    if (term.type === "city") args.radius = [...(args.radius ?? []), `${term.id}+${term.radius}`]
                    return { ...args, [term.type]: [...(args[term.type] ?? []), term.slug ?? term.id]}
                }, {})
        },
        removeParameter(key: string, value: string) {
            if (!this.selectedParams.hasOwnProperty(key)) return
            this.selectedParams[key] = Array.isArray(this.selectedParams[key])
                ? this.selectedParams[key].filter((term: string) => term !== value) : "default"
        },
        submitFilter() {}
    }
}
